module.exports = __webpack_public_path__ + "static/media/linkedin-contact.3a710011.svg";